import { ReactNode, useEffect } from 'react';
import Nav, { linkProps } from 'views/Aide/Scenario/PolicyForm/NoRegionForm/Nav';
import { FV } from './share';
import { Element, scroller } from 'react-scroll';
import { NoRegionContainer, NoRegionWrapper } from 'views/Aide/Scenario/PolicyForm/NoRegionForm';
import { StyledForm } from 'views/Aide/Scenario/PolicyForm';
import { useTranslate } from '@tolgee/react';
import Regions from 'views/Aide/Scenario/PolicyForm/NoRegionForm/Regions';
import TodoRegionExecuteContextsField from './RegionExecuteContextsField';
import { ResultType } from './ResultType';
import { useReactScrollContext } from 'views/Aide/components/ReactScrollContext';

export interface FormContentProps {
  header?: ReactNode;
  footer?: ReactNode;
  readonly?: boolean;
  defaultActiveRegion?: General.UpperCaseRegion;
}

function FormContent(props: FormContentProps) {
  const { header, footer, readonly, defaultActiveRegion } = props;

  const { t } = useTranslate();

  const { containerId, basicId, createRegionContextId } = useReactScrollContext();

  const nav = <Nav<FV> basicValidate={(errors) => !errors.regions} />;

  useEffect(() => {
    if (defaultActiveRegion) {
      const action = () => {
        scroller.scrollTo(createRegionContextId(defaultActiveRegion), {
          ...linkProps,
          containerId,
          duration: 0,
        });
      };

      if (requestAnimationFrame) {
        requestAnimationFrame(action);
      } else {
        action();
      }
    }
  }, [defaultActiveRegion, containerId, createRegionContextId]);

  return (
    <NoRegionContainer>
      {header}
      <NoRegionWrapper>
        {nav}
        <section>
          <StyledForm colon>
            <Element name={basicId}>
              <h3>{t('aide.基础配置')}</h3>
              <ResultType />
              {<Regions disabled={readonly} />}
            </Element>
            <TodoRegionExecuteContextsField disabled={readonly} />
          </StyledForm>
          {footer}
        </section>
      </NoRegionWrapper>
    </NoRegionContainer>
  );
}

export default FormContent;
